




















import { defineComponent, PropType, ref } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useTags from "@/hooks/useTags";
import { $t } from "@/lib/i18nHelpers";
import BaseSpinner from "@/components/BaseSpinner";
import SelectTagsView from "@/components/SelectTagsView";

export default defineComponent({
  name: "TagsController",
  components: { BaseSpinner, SelectTagsView },
  props: {
    selectedTagIds: { type: Array as () => string[], required: true },
    tagsType: { type: String as () => TagInfoType, required: true },
    minSelectedTags: { type: Number, default: 0 },
    maxSelectedTags: { type: Number, default: 5 },
    maxRows: { type: Number, default: 0 },
    scrollable: { type: Boolean, default: false },
    showSaveButton: { type: Boolean },
    saveButtonText: { type: String as PropType<TranslateResult | string>, default: $t("Save") },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const { getTags, tags } = useTags([props.tagsType]);

    const onSave = (selectedTags: TagInfo[], cb?: Function) => {
      emit("select", selectedTags);
      cb && cb();
    };
    const getData = async () => {
      try {
        loading.value = true;
        await getTags();
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      tags,
      getTags,
      onSave,
    };
  },
});
